export const DEFAULT_API_BASE_URL = '/api';
export const DEFAULT_REQUEST_TIMEOUT_MS = 95000;
